import { render, staticRenderFns } from "./peopleDetail.vue?vue&type=template&id=c7069800&scoped=true&"
import script from "./peopleDetail.vue?vue&type=script&lang=js&"
export * from "./peopleDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/resource/peopleDetail.less?vue&type=style&index=0&id=c7069800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7069800",
  null
  
)

component.options.__file = "peopleDetail.vue"
export default component.exports